import React from 'react'
import {langTranslate} from 'helper/arabic'
import { appPrefix } from 'helper/browserHelper'

const Footer = () => {
    return (
        <>
            <ul className="fs-2 ls-reset flex flex-wrap lh-copy" data-testid="footerForCOM">
                <li className="c-neutral-400 fw-500 mr-4 mb-1">{langTranslate('Other Tools:')}</li>
                <li className="mr-4 mb-1">
                    <a
                        href={`${appPrefix}/`}
                        className="c-neutral-200 td-none hover:td-underline"
                        title="Flight Booking"
                    >
                        {langTranslate('Cheap air tickets')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        href={`${appPrefix}/flights`}
                        className="c-neutral-200 td-none hover:td-underline"
                        title="Book cheap flights for travel within India and abroad"
                    >
                        {langTranslate('Flight tickets')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        title="India Hotels"
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/hotels/india/`}
                    >
                        {langTranslate('India Hotels')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        title="Check Flight Status"
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/status`}
                    >
                        {langTranslate('Check Flight Status')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        title="IRCTC Trains Reservation"
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/trains`}
                    >
                        {langTranslate('IRCTC Railway Reservation')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        title="Indian Railways PNR Status"
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/trains/pnr`}
                    >
                        {langTranslate('Indian Railways PNR Status')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        title="Tatkal booking"
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/tourism/train/tatkal-booking.html`}
                    >
                        {langTranslate('Tatkal booking')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        title="IRCTC Seat Availability"
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/trains/calendar`}
                    >
                        {langTranslate('IRCTC Seat Availability')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        title="List of stations"
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/trains/stations/list`}
                    >
                        {langTranslate('List of stations')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        title="List of trains"
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/trains/list`}
                    >
                        {langTranslate('List of trains')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-tickets/cheap-flight-air-tickets-domestic.html`}
                        title="Domestic Air Tickets"
                    >
                        {langTranslate('Cheap Domestic Air Tickets')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        title="Domestic Flight Schedules"
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-schedule/flight-schedules-domestic.html`}
                    >
                        {langTranslate('Domestic Flights')}{' '}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        title="Domestic Airlines in India"
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-booking/domestic-airlines.html`}
                    >
                        {langTranslate('Domestic Airlines in India')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        href={`${appPrefix}/flight-tickets/cheap-flight-air-tickets-international.html`}
                        title="International Air Tickets"
                        className="c-neutral-200 td-none hover:td-underline"
                    >
                        {langTranslate('International Air Tickets')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        title="International Flight Schedules"
                        href={`${appPrefix}/flight-schedule/flight-schedules-international.html`}
                        className="c-neutral-200 td-none hover:td-underline"
                    >
                        {langTranslate('International Flights')}{' '}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        title="International Airlines"
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/flight-booking/international-airlines.html`}
                    >
                        {langTranslate('International Airlines')}
                    </a>
                </li>
                <li className="mr-3 mb-1">
                    <a
                        title="Flight plus Hotel Packages"
                        className="c-neutral-200 td-none hover:td-underline"
                        href={`${appPrefix}/tourism/packages/`}
                    >
                        {langTranslate('Holiday Packages')}
                    </a>
                </li>
            </ul>
        </>
    )
}

export default Footer
